var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banner && _vm.banner.picture)?_c('div',{staticClass:"home-banner-holder"},[(_vm.banner)?_c('DynamicLinker',{staticClass:"d-flex",attrs:{"item":_vm.banner}},[_c('img',{staticClass:"w-100",attrs:{"loading":"lazy","src":_vm.banner.picture,"alt":"banner"}})]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }